import ReactBlack from '../../assets/skills/black/react-black.svg'
import ReactWhite from '../../assets/skills/white/react-white.svg'
import JavascriptBlack from '../../assets/skills/black/javascript-black.svg'
import JavascriptWhite from '../../assets/skills/white/javascript-white.svg'
import BootstrapBlack from '../../assets/skills/black/bootstrap-black.svg'
import BootstrapWhite from '../../assets/skills/white/bootstrap-white.svg'
import RubyWhite from '../../assets/skills/white/ruby-white.svg'
import RubyBlack from '../../assets/skills/black/ruby-black.svg'
import RailsWhite from '../../assets/skills/white/rails-white.svg'
import RailsBlack from '../../assets/skills/black/rails-black.svg'
import PHPWhite from '../../assets/skills/white/php-white.svg'
import PHPBlack from '../../assets/skills/black/php-black.svg'
import PostgreWhite from '../../assets/skills/white/postgre-white.svg'
import PostgreBlack from '../../assets/skills/black/postgre-black.svg'
import WordpressWhite from '../../assets/skills/white/wordpress-white.svg'
import WordpressBlack from '../../assets/skills/black/wordpress-black.svg'
import TailwindWhite from '../../assets/skills/white/tailwind-white.svg'
import TailwindBlack from '../../assets/skills/black/tailwind-black.svg'
import SASSWhite from '../../assets/skills/white/sass-white.svg'
import SASSBlack from '../../assets/skills/black/sass-black.svg'
import HTMLWhite from '../../assets/skills/white/html-white.svg'
import HTMLBlack from '../../assets/skills/black/html-black.svg'
import CSSWhite from '../../assets/skills/white/css-white.svg'
import CSSBlack from '../../assets/skills/black/css-black.svg'
import XDWhite from '../../assets/skills/white/xd-white.svg'
import XDBlack from '../../assets/skills/black/xd-black.svg'
import TSWhite from '../../assets/skills/white/Typescript-white.svg'
import TSBlack from '../../assets/skills/black/Typescript-black.svg'
import NextJSWhite from '../../assets/skills/white/Nextjs-white.svg'
import NextJSBlack from '../../assets/skills/black/Nextjs-black.svg'


export const skills = [
    {
        name: "JavaScript",
        imageWhite: JavascriptWhite,
        imageBlack: JavascriptBlack
    },
    {
        name: "TypeScript",
        imageWhite: TSWhite,
        imageBlack: TSBlack
    },
    {
        name: "React.js",
        imageWhite: ReactWhite,
        imageBlack: ReactBlack
    },
    {
        name: "Next.js",
        imageWhite: NextJSWhite,
        imageBlack: NextJSBlack
    },
    {
        name: "Ruby",
        imageWhite: RubyWhite,
        imageBlack: RubyBlack
    },
    {
        name: "Rails",
        imageWhite: RailsWhite,
        imageBlack: RailsBlack
    },
    {
        name: "PHP",
        imageWhite: PHPWhite,
        imageBlack: PHPBlack
    },
    {
        name: "PostgreSQL",
        imageWhite: PostgreWhite,
        imageBlack: PostgreBlack
    },
    {
        name: "WordPress",
        imageWhite: WordpressWhite,
        imageBlack: WordpressBlack
    },
    {
        name: "Tailwind",
        imageWhite: TailwindWhite,
        imageBlack: TailwindBlack
    },
    {
        name: "SASS",
        imageWhite: SASSWhite,
        imageBlack: SASSBlack
    },
    {
        name: "Bootstrap",
        imageWhite: BootstrapWhite,
        imageBlack: BootstrapBlack
    },
    {
        name: "HTML",
        imageWhite: HTMLWhite,
        imageBlack: HTMLBlack
    },
    {
        name: "CSS",
        imageWhite: CSSWhite,
        imageBlack: CSSBlack
    },
    {
        name: "XD",
        imageWhite: XDWhite,
        imageBlack: XDBlack
    },
]